<template>
  <!-- no-flip: near the bottom of the window the menu used to flip upward and run off the top of
       the screen, cut off with no way to scroll it. it always opens downward and scrolls now. -->
  <b-dropdown :text="toggle_text" variant="outline-secondary" toggle-class="gms-multi-toggle" menu-class="gms-multi-menu" no-flip boundary="window" :style="{ minWidth: width }">
    <b-dropdown-form>
      <b-form-checkbox-group :checked="value" :options="checkbox_options" stacked @input="$emit('input', $event)"/>
    </b-dropdown-form>
    <b-dropdown-divider/>
    <b-dropdown-item-button @click="$emit('input', [])">Clear (All {{plural}})</b-dropdown-item-button>
  </b-dropdown>
</template>

<script>
// group message sender filter: pick any number of values, none picked means all
export default {
  name: 'GmsMultiSelect',
  props: {
    value: { type: Array, default: () => [] },
    // the backend's option list, which leads with an { value: '', text: 'All' } entry
    options: { type: Array, default: () => [] },
    plural: { type: String, required: true },
    width: { type: String, default: '200px' },
  },
  computed: {
    checkbox_options() {
      return this.options.filter(option => option.value != '')
    },
    toggle_text() {
      if (this.value.length == 0)
        return 'All'
      if (this.value.length == 1) {
        // the option's own label, minus its "(n)" count -- so "Not set" reads as words, not its value
        const option = this.options.find(option => option.value == this.value[0])
        return option ? String(option.text).replace(/\s\(\d+\)$/, '') : this.value[0]
      }
      return this.value.length + ' ' + this.plural.toLowerCase()
    },
  },
}
</script>

<style>
  .gms-multi-toggle {
    font-size: 20px;
    font-weight: bold;
    width: 100%;
  }

  /* opening downward means the menu has to fit whatever room is left below the
     toggle, so it scrolls rather than running past the bottom of the window */
  .gms-multi-menu {
    max-height: 400px;
    max-height: min(400px, 60vh);
    overflow-y: auto;
    white-space: nowrap;
  }
</style>
